/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";

const config = require("data/siteConfig");

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.center}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/"
                className={classes.block}
                target="_self"
              >
                Home
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/what-we-do"
                className={classes.block}
                target="_self"
              >
                What We Do
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/our-team"
                className={classes.block}
                target="_self"
              >
                Our Team
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/careers"
                className={classes.block}
                target="_self"
              >
                Careers
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/contact-us"
                className={classes.block}
                target="_self"
              >
                Contact Us
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href={`https://docs.` + config.siteUrl}
                className={classes.block}
                target="_blank"
              >
                Docs
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/login"
                className={classes.block}
                target="_self"
              >
                Login
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/terms"
                className={classes.block}
                target="_self"
              >
                Terms
              </a>
            </ListItem>
          </List>
        </div>
        <div className={classes.center}>
          &copy; {1900 + new Date().getYear()} {config.siteTitle}
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool,
};
